import { Component } from '../lib/component'
import { Browser } from "./browser"
export class Content extends Component {
    constructor(options){
        super(options)
        window.content = this
        this.items = {
            content : {}
        }

        this.widgets
        this.fetchWidgets()
        this.tickertapes
        this.fetchTickertapes()
        this.onLoad
        this.ready
    }

    fetchFiles(path = path?.path ? path.path : '/content',ready){
        console.log('fetchFiles')

        if(path.path) path = path.path
        ui.API.get(path, response => {

            const table = response.querySelector('table') ? response.querySelector('table') : response.querySelector('.container.h-500'),
                  item = { title : response.querySelector('h2').textContent.replace((/  |\r\n|\n|\r/gm),''),table : table },
                  folders = table.querySelectorAll('[data-content-type="folder"]')

            if(table.hasAttribute('data-root')){
                // root
                this.root = item
                //sessionStorage.setItem('root', JSON.stringify(item))
            }

            this.items[path] = item
            table.querySelectorAll('tbody tr').forEach( row => {
                if(row.dataset.contentType != 'folder'){
                    this.items.content[row.id] = {
                        type : row.dataset.contentType,
                        extension : row.dataset.contentExtension,
                        size : row.querySelector('.size').textContent.replace((/  |\r\n|\n|\r/gm),''),
                        resolution : row.querySelector('.resolution').textContent.replace((/  |\r\n|\n|\r/gm),'')
                    }

                    if(row.dataset.contentDuration)
                        this.items.content[row.id].duration = row.dataset.contentDuration
                    row.addEventListener('click',this.content)
                }
                if(row.dataset.contentType === 'folder'){
                    const last_folder = row === folders[folders.length-1]
                    this.fetchFiles(`/content/folder/${row.id}`,last_folder ? true : false)
                    row.addEventListener('click', this.content)
                    row.addEventListener('contextmenu', (event)=> {
                        event.preventDefault();
                        this.folder(event);
                    })
                }
            })
            if(ready) this.ready = ready
            if(!folders?.length) this.ready = true
            if(!this.items.content.length) this.ready = true
            if(typeof this.onLoad === 'function' && this.ready){
                this.onLoad()
            }

        })
    }
    fetchWidgets(){
        console.log('fetchWidgets')
        ui.API.get('/widget', response => {
            const table = response.querySelector('table') ? response.querySelector('table') : response.querySelector('.container.h-500')
            table.querySelectorAll('tbody tr').forEach( row => {
                row.querySelectorAll('a').forEach(a => a.removeAttribute('href'))
                // row.querySelector('a').removeAttribute('href')
                row.addEventListener('click',this.widget)
            })
            this.widgets = table
        })
    }

    fetchTickertapes(){
        console.log('fetchTickertapes')
        ui.API.get('/tickertape', response => {
            const table = response.querySelector('table') ? response.querySelector('table') : response.querySelector('.container.h-500')
            table.querySelectorAll('tbody tr').forEach( row => {
                row.querySelector('a').removeAttribute('href')
                row.addEventListener('click',this.tickertape)
            })
            this.tickertapes = table
            this.fetchFiles(this.options)
        })
    }

    browse(path,folder,callback,save){
        console.log('Starting function browse')

        if(typeof path === 'function') {
            if(!save && typeof callback === 'function')
                save = callback

            callback = path
            path = undefined
        }
        const content = path ? window.content.items[path] : window.content.root
        // console.log(content.table)
        new Browser({
            title : content.title,
            content : content.table,
            widgets : this.widgets,
            tickertapes : this.tickertapes,
            onLoad(){
                //console.log('browse.onLoad')
                const rows = content.table.querySelectorAll('tbody tr')
                if(content.table.querySelector('thead th.actions'))
                    content.table.querySelector('thead th.actions').remove()
                    ui.modal.footer.querySelector('.btn-primary').classList.add('d-none')
                    if (ui.modal.footer.querySelector('.btn-info'))
                        ui.modal.footer.querySelector('.btn-info').classList.add('d-none')
                rows.forEach( row => {
                    row.querySelector('.actions')?.remove()
                    row.querySelectorAll('a').forEach(a => a.removeAttribute('href'))
                    row.style.cursor = 'pointer'
                })
                if(content.table.hasAttribute('data-root')){
                    //console.log('isRoot')
                }else{
                    ui.modal.footer.prepend(ui.element('span',{ class : 'btn btn-primary',click(){
                        window.content.browse(null,null,callback,save)
                    }},__('Back to')+' '+__('Root Folder')))

                    // Below option will add all files in the folder to the playlist.
                    ui.modal.footer.prepend(ui.element('span',{ class : 'btn btn-info text-dark',click(){
                        console.log('FOLDER', folder)
                        ui.modal.footer.querySelector('.btn-primary').textContent = __('Add')
                        const item = {
                            id : folder.id,
                            type : 'folder',
                            name : folder.querySelectorAll('a')[1].textContent.replace((/  |\r\n|\n|\r/gm),'')
                        }
                        console.log('This is the item: ', item)            
                        callback(item)
                    }},__('Add all files in folder')))
                }
            },
            onSave : save
          })
    }

    content(event, callback = content.options.callback){
        console.log('Starting function content')
        const row = event.currentTarget,
              id = row.id,
              type = row.dataset.contentType
        console.log('ROW', row)

        if(type === 'folder'){
            window.content.browse('/content/folder/'+id, row, callback)
        }else{
            console.log('Load Playlist item')
            //console.log(ui.modal.footer.querySelector('.btn-primary'))
            ui.modal.footer.querySelector('.btn-primary').classList.remove('d-none')
            const thumb = type === 'image' || type === 'video' ? row.querySelector('img') : null,
            item = {
                id : row.id,
                type : row.dataset.contentType,
                extension : row.dataset.contentExtension,
                size : row.querySelector('.size') ? row.querySelector('.size').textContent.replace((/  |\r\n|\n|\r/gm),'') : null,
                resolution : row.querySelector('.resolution').textContent.replace((/  |\r\n|\n|\r/gm),''),
                thumb : thumb,
                name : row.querySelectorAll('a')[1].textContent.replace((/  |\r\n|\n|\r/gm),'')
            }
            if(row.dataset.contentDuration){
                item.duration = row.dataset.contentDuration
            }
            console.log('This is the item: ', item)
            ui.modal.footer.querySelector('.btn-primary').textContent = __('Add')
            callback(item) // open content
        }
    }

    widget(event,callback = content.options.callback){
        const row = event.currentTarget,
              id = row.id,
              item = {
                id : id,
                type : 'widget',
                name : row.dataset.name,
                source : row.querySelectorAll('td')[3].textContent.replace((/  |\r\n|\n|\r/gm),'')
              }
              console.log('WIDGET ROW ', row)
              console.log('This is the Widget item: ', item)
              callback(item)
    }

    tickertape(event,callback = content.options.callback){
        const row = event.currentTarget,
              id = row.id,
              item = {
                id : id,
                type : 'tickertape',
                name : row.dataset.name
              }
        callback(item)
    }

    folder(event,callback = content.options.callback){
        console.log('Starting function folder')
        const row = event.currentTarget,
              id = row.id,
              item = {
                id : id,
                type : 'folder',
                name : row.querySelectorAll('a')[1].textContent.replace((/  |\r\n|\n|\r/gm),'')
              }
        console.log('This is the item: ', item)
        callback(item)
    }
}
